import { signal } from '@preact/signals';
import { UserType } from '@ccmn/rhino';

export interface UserStoreProps {
    screenName: string | undefined;
    isLoggedIn: boolean | undefined;
    ccMailNewMessagesCount: number | undefined;
    showRegWizard: boolean | undefined;
    isStudioMember: boolean | undefined;
    token: string | null;
    userID: number | undefined;
    userTypeID: UserType;
    profileUrl: string | undefined;
    isStudioOwner: boolean | undefined;
}

export default function createUserStore(props: UserStoreProps) {
    const { screenName, isLoggedIn, ccMailNewMessagesCount, showRegWizard, isStudioMember, token, userTypeID, profileUrl, isStudioOwner, userID }: UserStoreProps = props;

    return {
        screenName: signal(screenName),
        isLoggedIn: signal(isLoggedIn),
        ccMailNewMessagesCount: signal(ccMailNewMessagesCount),
        showRegWizard: signal(showRegWizard),
        isStudioMember: signal(isStudioMember),
        token: signal(token),
        userID: signal(userID),
        userTypeID: signal(userTypeID),
        profileUrl: signal(profileUrl),
        isStudioOwner: signal(isStudioOwner),
    };
}
